//=======================| App Configuration |========================//
export default {
    appUrlBackEnd: 'https://sislii.com',
    // appUrlBackEnd: 'https://sislii.test',
    appLogo: '/static/images/logo.svg',
    appLogoDark: '/static/images/logo-dark.svg', // App Logo,
    brand: 'Sislii', // Brand Name
    copyrightText: '© Todos los derechos reservados | Hecho con amor por Sislii', // Copyright Text
    //theme color
    color: {
        primary: '#1b2831',
        accent: '#E21E42',
    },
    algoliaApiKey: '6be0576ff61c053d5f9a3225e2a90f76',
};
